import React, { Component } from "react";
import Label from "../../component/Label/Label";
import Modal from "../../component/Modal/Modal";
import RadioButton from "../../component/RadioButton/RadioButton";
import Tabs from "../../component/Tabs/Tabs";
import TextInput from "../../component/TextInput/TextInput";
import InpatientStatus from "../../../core/constants/InpatientStatus";
import PatientSex, {PatientSex3} from "../../../core/constants/PatientSex";
import ComboBox from "../../component/ComboBox/ComboBox2";
import Button from "../../component/button/Button";
import Patient from "../../../core/api/Patient/Patient";
import Study from "../../../core/api/Study2/Study";
import {_alert} from "../../../actions/Alert";
import {_loading} from "../../../actions/Loading";
import { connect } from "react-redux";
import eventBus from "../../../core/utils/EventBus";
import T from "../../component/t/T";
import Storage from "../../../helpers/Storage";
import "./AddPatient.scss";
import snippets from "../../../helpers/snippets";
import CheckBox from "../../component/CheckBox/CheckBox";
import Uploader from "../../component/uploader/Uploader";

const patient = new Patient();
const study = new Study();
class AddPatient extends Component {
  constructor(props) {
    super(props);

    this.timer = 0

    this.state = {
      language: Storage.getLanguage(),
      tabs: [
        {
          id: 1,
          title: "his_requests",
          icon: "fal fa-hospital-symbol"
        },
        {
          id: 2,
          title: "register",
          icon: "fal fa-user-alt"
        }
      ],
      activeTabID: 1,
      modalities: [],
      serviceCodeGroups: [],
      disabled: false,
      requestID: null,
      patientID: null,
      patientFirstNameFa: "",
      patientFirstNameEn: "",
      patientLastNameFa: "",
      patientLastNameEn: "",
      sex: null,
      patientStatus: null,
      modality: null,
      images: [],
      hisRequests: [],
      hisName: "",
      hisCode: "",
      requestCode: "",
      selectedRequestCodes: new Set(),
      fillFromHISTab: null,
      page: 1,
      disableGoAction: true,
      paginator: [1],
      limit: 8
    };
  }

  // Lifecycle methods
  componentDidMount() {
    this.#getModalityData();
    this.#getRequestsFromHIS();
    this.#getServiceCodeGroupsData();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.language !== this.props.language) {
      this.setState({language: this.props.language});
    }
  }

  // Private methods
  #getModalityData = () => {
    this.props.dispatch(_loading(true));
    let processedData = [];
    let modalities = Storage.getModalities() || [];

    modalities.forEach(modality => {
      if (modality?.is_virtual === true) {
        processedData.push({
          id: modality.id,
          text: modality.name,
          value: modality.modality
        });
      }
    });
    
    this.setState({
      modalities: [{
        id: -1,
        text: "all",
        value: ""
      }, ...processedData]
    });
  }

  #getServiceCodeGroupsData = () => {
    let processedData;
    let serviceCodeGroups = Storage.getServiceCodeGroups() || [];

    processedData = serviceCodeGroups.map(serviceCodeGroup => ({
        id: serviceCodeGroup.id,
        text: serviceCodeGroup.name,
        value: serviceCodeGroup.id
    }));
    
    this.setState({
      serviceCodeGroups: [{id: -1, text: "all", value: ""} ,...processedData]
    }, () => {
      this.props.dispatch(_loading(false));
    });
  }

  #setPaginator = (fetchedRecordsCount, newCurrentPage) => {
    let paginator = [...this.state.paginator];

    if (newCurrentPage > this.state.page || paginator.length <= 1) {
        let newPage = this.state.paginator[this.state.paginator.length - 1] + 1;

        
        if (fetchedRecordsCount >= this.state.limit) {
            let exist = paginator.find(item => item === newCurrentPage);
            let lastIndex = this.state.paginator[this.state.paginator.length - 1];
            
            if (!exist || newCurrentPage === lastIndex)
                paginator = [...this.state.paginator, newPage];
        }
    }

    if (newCurrentPage === 1 && fetchedRecordsCount < this.state.limit) {
        paginator = [1];
    }

    return paginator;
  }

  #getRequestsFromHIS = (pageNumber = 1, disableLoading = false) => {
    if (!disableLoading)
      this.props.dispatch(_loading(true));

    study.searchHIS({
      code: this.state.hisCode,
      name: this.state.hisName,
      request_code_id: this.state.requestCode,
      page: pageNumber,
      limit: this.state.limit,
    }).then(response => {
      this.setState({
        selectedRequestCodes: new Set(),
        hisRequests: [...response.data.studies],
        page: pageNumber,
        disableGoAction: snippets.isObjectEmpty(response.data.studies) ? true : response.data.studies.length < this.state.hisRequests.length,
        paginator: this.#setPaginator(response.data.studies.length, pageNumber),
      }, ()=>{
        if (this.state.hisRequests.length === 1) {
          this.handleClickOnHISRow(2, this.state.hisRequests[0])
        }
      });
    }).catch(error => console.log(error)).finally(() => {
      if (!disableLoading)
        this.props.dispatch(_loading(false));
    });
  }

  // Public methods
  handleActiveTabChange = (selectedTabID) => {
    this.setState({
      activeTabID: selectedTabID
    });
  }

  checkSelectedCodes = () => {
    if (this.state.selectedRequestCodes.size === 1 ) {
      this.getPatientInfo(Array.from(this.state.selectedRequestCodes).shift())
    } else {
      let requests = {}
      Array.from(this.state.selectedRequestCodes).map(item => {
        let id = item.substring(0, item.lastIndexOf("-"))
        snippets.addElementToSetInObject(requests, id, item.substring(item.lastIndexOf("-")+1))
      })
      if (Object.keys(requests).length === 1) {
        let lst = Object.entries(requests).map(([key,value]) =>  {return `${key}-${Array.from(value).join(",")}`})
        this.getPatientInfo(Array.from(this.state.selectedRequestCodes).shift(), lst)
      }
      else {
        this.props.dispatch(_alert(true, "error", <T token={"not_same_barcode"} />))
      }
    }
  }

  closeModalHandler = () => {
    this.props.closeModal();
  }

  handleRegisterValues = (e) => {
    this.handleByKeyValue(e.target.name, e.target.value, false)
  }

  handleRegisterValuesTimerSearch = (e) => {
    this.handleByKeyValue(e.target.name, e.target.value, true)
  }

  handleByKeyValue = (key, value, timer = false) => {
    if (this.timer && timer){
      clearTimeout(this.timer);
    }
    this.setState({[key]: value}, ()=>{
      timer && (this.timer = setTimeout(() => this.handleHisSearchButton(), 700))
    });
  }

  handleResetButton = () => {
    this.setState({
      requestID: null,
      patientID: null,
      patientFirstNameFa: "",
      patientFirstNameEn: "",
      patientLastNameFa: "",
      patientLastNameEn: "",
      sex: null,
      patientStatus: null,
      modality: null,
      images: [],
      fillFromHISTab: null
    });
  }

  handleOpenReportButton = (studyID) => {
    window.open(`/#/report/${studyID}/0`, "_blank");
  }

  handleHisSearchButton = () => {
    this.#getRequestsFromHIS();
  }

  handleUpdateFromHis = () => {
    let message = {
      type: "",
      text: ""
    };

    this.props.dispatch(_loading(true));

    study.updateFromHIS().then(response => {
      this.#getRequestsFromHIS(1, true);

      message.type = "success";

      if (response.data.msg.length > 0 ) {
        message.text = response.data.msg;
      }
      else {
        message.text = response.msg;
      }

    }).catch(error => {
      message.type = "error";
      message.text = error.response.data.msg;
    }).finally(() => {
      this.props.dispatch(_loading(false));
      this.props.dispatch(_alert(true, message.type, message.text));
    });
  }

  handleRegisterSaveButton = () => {
    this.props.dispatch(_loading(true));

    this.setState({
      disabled: true
    }, () => {
      patient.create({
        patient_code: this.state.patientID,
        request_number: this.state.requestID,
        first_name: this.state.patientFirstNameEn,
        his_first_name: this.state.patientFirstNameFa,
        last_name: this.state.patientLastNameEn,
        his_last_name: this.state.patientLastNameFa,
        sex: this.state.sex,
        inpatient_status: this.state.patientStatus,
        modalities: this.state.modality
      }).then(response => {
        if (!snippets.isObjectEmpty(response.data?.data)) {
          const {study} = response.data.data;
          this.setState({
            fillFromHISTab: this.getStudyIDFromReport(study)
          }, () => {
            // this.closeModalHandler()
            eventBus.dispatchEvent("reloadData");
          });
        }
      }).finally(() => {
        this.setState({
          disabled: false
        }, () => {});
      });
    });
  }

  handleClickOnHISRow = (event, request, callBackFn = ()=>{}) => {
    let already_registered = request?.already_registered
    let requestID =  request?.request_id
    if (already_registered){
        this.props.dispatch(_alert(true, "error", <T token={"duplicated_report_for_study"} />));
    } else if (event === 1) {
      if ( this.state.selectedRequestCodes.has(requestID) ){
        let lst = this.state.selectedRequestCodes
        lst.delete(requestID)
        this.setState({selectedRequestCodes: lst}, callBackFn)
      } else {
        let lst = this.state.selectedRequestCodes
        lst.add(requestID)
        this.setState({selectedRequestCodes: lst}, callBackFn)
      }
    } else if (event === 2){
      this.setState({selectedRequestCodes: new Set()},()=>{
        this.handleClickOnHISRow(1, request, this.checkSelectedCodes)
      })
    }
  }

  getPatientInfo = (requestID, requestList = null) =>{
    study.studyInfoForReport(0, requestID).then(response => {
      const {study, patient} = response.data;

      this.setState({
        requestID: requestList ?? requestID,
        patientID: patient.patient_id,
        patientFirstNameFa: patient.his_first_name,
        patientFirstNameEn: patient.first_name,
        patientLastNameFa: patient.his_last_name,
        patientLastNameEn: patient.last_name,
        sex: patient.sex,
        patientStatus: study.inpatient_status,
        modality: study.modalities,
        activeTabID: 2,
        fillFromHISTab: this.getStudyIDFromReport(study)
      });
    }).catch(error => {console.error(error)});
  }
  
  getStudyIDFromReport = (study) => {
    return snippets.isObjectEmpty(study.reports) ? null : study.reports?.[0]?.study_id
  }

  requestRow = (request) => {
    let disabled = request.already_registered

    return <>
      <div key={request?.request_id} className={`requests__table__body__row ${ disabled ? "disabled" : ""}`}
           onDoubleClick={() => this.handleClickOnHISRow(2, request)}
           onClick={()=>this.handleClickOnHISRow(1, request)}
      >
        <div className="cell" >
          <CheckBox disabled={disabled}
                    handleChangeValue={()=>this.handleClickOnHISRow(1, request)}
                    checked={this.state.selectedRequestCodes.has(request.request_id)}
          />

        </div>
        <div className="cell">{ request.patient_id } <br /> { request.national_code } <br /> { request.request_id }</div>
        <div className="cell">{ request.first_name } <br /> { request.last_name }</div>
        <div className="cell"> <T token={PatientSex3(request.sex)} /> </div>
        <div className="cell">{ snippets.datetime(request.create_date) } <br /> { request.create_time }</div>
        <div className="cell ellipsis-multiline-3">{ request.code } <br /> { request.request_title }</div>
      </div>
    </>
  }

  renderRequestHIS = () => {
    const rightOrLeft = this.state.language === "fa" ? "right" : "left";
    const opposite = this.state.language === "fa" ? "left" : "right";
    
    return <div className="his-requests__form">
      <div className="hr-filters__row">
        <TextInput label="request_number"
                   placeholder="his_request_number_filter_placeholder"
                   removeColon
                   defaultValue={this.state.hisCode}
                   name="hisCode"
                   handleChange={this.handleRegisterValuesTimerSearch}
                   config={{autoFocus: true}} />
        
        <TextInput label="full_name"
                   placeholder="first_last_name"
                   removeColon
                   defaultValue={this.state.hisName}
                   name="hisName"
                   handleChange={this.handleRegisterValuesTimerSearch} />

        <ComboBox fullWidth
                  inlineLabel={false}
                  removeColon={true}
                  labelText="request_type"
                  comboboxValues={this.state.serviceCodeGroups}
                  nonTransparent
                  fieldName="request_code"
                  changeValueHandler={value => this.handleByKeyValue("requestCode", value, true)} />
      </div>
      <div className="hr-content__row">
        <div className="requests__table__header">
          <div className="cell">
          </div>
          <div className="cell">
            <T token={"his_request_number_filter_placeholder"} />
          </div>
          <div className="cell">
            <T token={"first_last_name"} />
          </div>
          <div className="cell">
            <T token={"sex"} />
          </div>
          <div className="cell">
            <T token={"date"} />
          </div>
          <div className="cell">
            <T token={"service_code"} />
            <br />
            <T token={"request"} />
          </div>
        </div>
        <div className="requests__table__body">
          {
            this.state.hisRequests.map((request) => this.requestRow(request))
          }
        </div>
        <div className="requests__table__footer">
          <div className={'pager'}>
              <div className="pager__container">
                  <Label labelText="results" labelRawText={this.state.hisRequests.length}/>
                  <div className={`actions__container`} style={{justifyContent: "center"}}>
                      <div className={'pager__action ' + (this.state.page === 1 && ' pager__action--disable')}
                          onClick={() => this.#getRequestsFromHIS(this.state.page - 1)}>
                          <i className={`fa fa-light fa-arrow-${rightOrLeft}`}/>
                      </div>
                      {
                          this.state.paginator.map((item) => <div key={item} className={`pager__action ${item === this.state.page ? "active" : ""}`} onClick={() => this.#getRequestsFromHIS(item)}>
                              { item }
                          </div>)
                      }
                      <div className={'pager__action ' + (this.state.disableGoAction && 'pager__action--disable')}
                          onClick={() => this.#getRequestsFromHIS(this.state.page + 1)}>
                          <i className={`fa fa-light fa-arrow-${opposite}`}/>
                      </div>
                  </div>
              </div>
          </div>
          {/* <Pager start={this.state.page} resultCount={this.state.hisRequests.length} selectedPageSize={8} hidePageSize={true} hideNumbers={true} handleEvent={(pageNumber) => this.#getRequestsFromHIS(pageNumber)}/> */}
        </div>
      </div>
    </div>;
  }

  renderRegister = () => {
    return <div className="register__from">
      <div className="c__row">
        <div className="c__col">
          <TextInput label="request_number" placeholder="type_here" removeColon defaultValue={this.state.requestID} name="requestID" handleChange={this.handleRegisterValues} config={{autoFocus: true}} tabIndex={10}/>
        </div>
        <div className="c__col">
          <TextInput label="patient_code" removeColon defaultValue={this.state.patientID} name="patientID" handleChange={this.handleRegisterValues} tabIndex={11}/>
        </div>
      </div>
      <div className="c__row">
        <div className="c__col">
          <TextInput label="patient_name" placeholder="to_persian" removeColon defaultValue={this.state.patientFirstNameFa} name="patientFirstNameFa" handleChange={this.handleRegisterValues} tabIndex={12}/>
          <TextInput placeholder="to_english" defaultValue={this.state.patientFirstNameEn} name="patientFirstNameEn" handleChange={this.handleRegisterValues} tabIndex={14}/>
        </div>
        <div className="c__col">
          <TextInput label="patient_last_name" placeholder="to_persian" removeColon defaultValue={this.state.patientLastNameFa} name="patientLastNameFa" handleChange={this.handleRegisterValues} tabIndex={13}/>
          <TextInput placeholder="to_english" defaultValue={this.state.patientLastNameEn} name="patientLastNameEn" handleChange={this.handleRegisterValues} tabIndex={15}/>
        </div>
      </div>
      <div className="c__row__smaller-bigger">
        <div className="c__col" >
          <Label labelText="sex" removeColon />
        </div>
        <div className="c__col d-flex">
          <RadioButton inputName="sex" checked={this.state.sex == 1} text={PatientSex[1]} value={1} handleChange={this.handleRegisterValues} tabIndex={16}/>
          <RadioButton inputName="sex" checked={this.state.sex == 0} text={PatientSex[0]} value={0} handleChange={this.handleRegisterValues} />
        </div>
      </div>
      <div className="c__row__smaller-bigger">
        <div className="c__co">
          <Label labelText="patient_status" removeColon />
        </div>
        <div className="c__col d-flex">
          <RadioButton inputName="patientStatus" checked={this.state.patientStatus == 1} value={1} text={InpatientStatus[1]} handleChange={this.handleRegisterValues} tabIndex={18}/>
          <RadioButton inputName="patientStatus" checked={this.state.patientStatus == 2} value={2} text={InpatientStatus[2]} handleChange={this.handleRegisterValues} />
          <RadioButton inputName="patientStatus" checked={this.state.patientStatus == 3} value={3} text={InpatientStatus[3]} handleChange={this.handleRegisterValues} />
        </div>
      </div>
      <div className="c__row__smaller-bigger">
      <div className="c__col">
          <Label labelText="modality" removeColon />
        </div>
        <div className="c__col">
          <ComboBox comboboxValues={this.state.modalities} nonTransparent fieldName="modality" changeValueHandler={value => this.handleByKeyValue("modality", value, false)} selectedItem={this.state.modality} tabIndex={21}/>
        </div>
      </div>
      //TODO: Check it with back-end
      {/*<div className="c__row__smaller-bigger">*/}
      {/*  <div className="c__col">*/}
      {/*    <Label labelText="pictures" removeColon />*/}
      {/*  </div>*/}
      {/*  <div className="c__col d-flex">*/}
      {/*    <Uploader fieldName="images" application="add_patient"/>*/}
      {/*  </div>*/}
      {/*</div>*/}
    </div>;
  }

  renderFooter = () => {
    if (this.state.activeTabID === 2)
      return <>
      <Button key={"save"} mode="warning" buttonText="save" onClick={this.handleRegisterSaveButton} config={{disabled: this.state.disabled}} />
      <Button key={"reset"} mode="warning-outline" buttonText="reset" onClick={this.handleResetButton} config={{disabled: this.state.disabled}} />
      {
        this.state.fillFromHISTab && 
        <Button key={"report"} mode="success" buttonText="report_btn" onClick={() => this.handleOpenReportButton(this.state.fillFromHISTab)} config={{disabled: this.state.disabled}} />
      }
      </>;
    else
      return <>
      <Button key={"register_selected"} mode="warning" buttonText="register_selected" onClick={this.checkSelectedCodes} />
      <Button key={"update_list"} mode="warning-outline" buttonText="update_list" onClick={this.handleUpdateFromHis} config={{disabled: this.state.disabled}} />
      </>;
  }

  render() {
    let modalBody = null;
    let footer = this.renderFooter();

    switch (this.state.activeTabID) {
      case 1:
        modalBody = this.renderRequestHIS();
        break;
      case 2:
        modalBody = this.renderRegister();
        break;
      default:
        break;
    }

    return <Modal title="add_customer" className="AddPatient" closeModal={this.closeModalHandler} footer={footer}>
      <Tabs tabs={this.state.tabs} activeTab={this.state.activeTabID} handleChangeTab={this.handleActiveTabChange} />
      {
        modalBody
      }
    </Modal>;
  }
}

const mapStateToProps = state => {
  const language = state.LangReducer.language;
  
  return {language};
}

export default connect(mapStateToProps)(AddPatient);
